(function () {
	"use strict";

	/* Mobile navigation */
	const navToggle = document.querySelector("[data-nav-toggle]");
	const navMenu = document.querySelector("[data-nav-menu]");

	if (navToggle && navMenu) {
		navToggle.addEventListener("click", () => {
			const isOpen = navToggle.getAttribute("aria-expanded") === "true";
			navToggle.setAttribute("aria-expanded", String(!isOpen));
			navMenu.dataset.open = String(!isOpen);
			document.body.style.overflow = isOpen ? "" : "hidden";
		});

		navMenu.querySelectorAll("a").forEach((link) => {
			link.addEventListener("click", () => {
				navToggle.setAttribute("aria-expanded", "false");
				navMenu.dataset.open = "false";
				document.body.style.overflow = "";
			});
		});
	}

	/* FAQ accordion */
	document.querySelectorAll("[data-accordion]").forEach((accordion) => {
		accordion.querySelectorAll(".accordion__item").forEach((item, index) => {
			const trigger = item.querySelector(".accordion__trigger");
			const panel = item.querySelector(".accordion__panel");
			const icon = item.querySelector(".accordion__icon");

			if (!trigger || !panel) return;

			const panelId = panel.id || `accordion-panel-${index + 1}`;
			panel.id = panelId;
			trigger.setAttribute("aria-controls", panelId);
			trigger.setAttribute(
				"aria-expanded",
				item.dataset.open === "true" ? "true" : "false",
			);
			if (icon) icon.textContent = item.dataset.open === "true" ? "−" : "+";

			trigger.addEventListener("click", () => {
				const isOpen = item.dataset.open === "true";

				accordion.querySelectorAll(".accordion__item").forEach((other) => {
					if (other === item) return;
					other.dataset.open = "false";
					const otherTrigger = other.querySelector(".accordion__trigger");
					const otherIcon = other.querySelector(".accordion__icon");
					if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
					if (otherIcon) otherIcon.textContent = "+";
				});

				item.dataset.open = String(!isOpen);
				trigger.setAttribute("aria-expanded", String(!isOpen));
				if (icon) icon.textContent = isOpen ? "+" : "−";
			});
		});
	});

	/* Pricing toggle & cards */
	const pricingData = {
		kids: {
			packs: [
				{
					qty: "3 PACKS",
					each: "$12/each",
					total: 36,
					compare: 73.5,
					discount: "51% OFF",
					best: true,
				},
				{
					qty: "4 PACKS",
					each: "$10.50/each",
					total: 42,
					compare: 84,
					discount: "50% OFF",
					best: false,
				},
				{
					qty: "2 PACKS",
					each: "$13.50/each",
					total: 27,
					compare: 49,
					discount: "45% OFF",
					best: false,
				},
				{
					qty: "1 PACK",
					each: "$19.00",
					total: 19,
					compare: 24.5,
					discount: "22% OFF",
					best: false,
				},
			],
			image: "assets/images/lp-buzzpatch-dynamic-1-new-buzzpatch-60.png",
		},
		adults: {
			packs: [
				{
					qty: "3 PACKS",
					each: "$12/each",
					total: 36,
					compare: 73.5,
					discount: "51% OFF",
					best: true,
				},
				{
					qty: "4 PACKS",
					each: "$10.50/each",
					total: 42,
					compare: 84,
					discount: "50% OFF",
					best: false,
				},
				{
					qty: "2 PACKS",
					each: "$13.50/each",
					total: 27,
					compare: 49,
					discount: "45% OFF",
					best: false,
				},
				{
					qty: "1 PACK",
					each: "$19.00",
					total: 19,
					compare: 24.5,
					discount: "22% OFF",
					best: false,
				},
			],
			image: "assets/images/lp-buzzpatch-dynamic-1-adult-buzzpatch-40.png",
		},
	};

	let currentAudience = "kids";
	let selectedPack = 0;

	const pricingOptions = document.querySelector("[data-pricing-options]");
	const pricingImage = document.querySelector("[data-pricing-image]");
	const pricingCompare = document.querySelector("[data-pricing-compare]");
	const pricingTotal = document.querySelector("[data-pricing-total]");
	const pricingDiscount = document.querySelector("[data-pricing-discount]");
	const toggleBtns = document.querySelectorAll("[data-pricing-toggle]");

	function formatPrice(amount) {
		return `$${amount.toFixed(2)}`;
	}

	function renderPricingCards() {
		if (!pricingOptions) return;

		const packs = pricingData[currentAudience].packs;
		pricingOptions.innerHTML = packs
			.map(
				(pack, i) => `
      <button type="button" class="pricing-card${pack.best ? " pricing-card--active" : ""}"
        data-pricing-card="${i}" aria-pressed="${i === selectedPack ? "true" : "false"}">
        ${pack.best ? '<span class="badge--bestseller">BEST SELLER</span>' : ""}
        <span class="pricing-card__qty">${pack.qty}</span>
        <span class="pricing-card__price">${pack.each}</span>
      </button>`,
			)
			.join("");

		pricingOptions.querySelectorAll("[data-pricing-card]").forEach((card) => {
			card.addEventListener("click", () => {
				selectedPack = Number(card.dataset.pricingCard);
				updatePricing();
			});
		});

		updatePricing();
	}

	function updatePricing() {
		const pack = pricingData[currentAudience].packs[selectedPack];
		if (!pack) return;

		if (pricingCompare) pricingCompare.textContent = formatPrice(pack.compare);
		if (pricingTotal) pricingTotal.textContent = formatPrice(pack.total);
		if (pricingDiscount) pricingDiscount.textContent = pack.discount;
		if (pricingImage) pricingImage.src = pricingData[currentAudience].image;

		pricingOptions
			?.querySelectorAll("[data-pricing-card]")
			.forEach((card, i) => {
				const isSelected = i === selectedPack;
				card.setAttribute("aria-pressed", String(isSelected));
				card.classList.toggle("pricing-card--active", isSelected);
			});
	}

	toggleBtns.forEach((btn) => {
		btn.addEventListener("click", () => {
			currentAudience = btn.dataset.pricingToggle;
			selectedPack = 0;
			toggleBtns.forEach((b) =>
				b.setAttribute("aria-pressed", String(b === btn)),
			);
			renderPricingCards();
		});
	});

	if (pricingOptions) renderPricingCards();

	/* Pricing gallery nav */
	const galleryPrev = document.querySelector("[data-gallery-prev]");
	const galleryNext = document.querySelector("[data-gallery-next]");
	const galleryImages = [
		"assets/images/lp-buzzpatch-dynamic-1-new-buzzpatch-60.png",
		"assets/images/lp-buzzpatch-dynamic-1-new-buzzpatch-pack.png",
	];
	let galleryIndex = 0;

	function updateGallery(dir) {
		if (!pricingImage) return;
		galleryIndex =
			(galleryIndex + dir + galleryImages.length) % galleryImages.length;
		pricingImage.src = galleryImages[galleryIndex];
	}

	galleryPrev?.addEventListener("click", () => updateGallery(-1));
	galleryNext?.addEventListener("click", () => updateGallery(1));


   const track = document.getElementById('video-slider-track');
  const slides = document.querySelectorAll('.video-slider-slide');
  const dotsContainer = document.getElementById('video-slider-dots');
  let currentIndex = 0;

  // --- Drag & Swipe State Variables ---
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  let isClick = true; // Prevents video play if the action was a swipe

  slides.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.classList.add('video-slider-dot');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
  });

  const dots = document.querySelectorAll('.video-slider-dot');
  goToSlide(0);
function goToSlide(index) {
    const containerWidth = track.parentElement.offsetWidth;
    const slideWidth = slides[0].offsetWidth;
    
    // Calculate the exact spacing needed to center the active slide
    const centerOffset = (containerWidth - slideWidth) / 2;
    
    // Add the center offset to our translation math
    currentTranslate = -(index * slideWidth) + centerOffset;
    prevTranslate = currentTranslate;
    
    track.style.transition = 'transform 0.5s ease-in-out';
    track.style.transform = `translateX(${currentTranslate}px)`;
    
    dots.forEach(dot => dot.classList.remove('active'));
    dots[index].classList.add('active');
    
    document.querySelectorAll('video').forEach(vid => {
      vid.pause();
    });
    
    currentIndex = index;
  }

  window.addEventListener('resize', () => {
    const containerWidth = track.parentElement.offsetWidth;
    const slideWidth = slides[0].offsetWidth;
    const centerOffset = (containerWidth - slideWidth) / 2;
    
    currentTranslate = -(currentIndex * slideWidth) + centerOffset;
    prevTranslate = currentTranslate;
    track.style.transform = `translateX(${currentTranslate}px)`;
  });

  // --- Drag & Swipe Logic ---
  
  track.addEventListener('mousedown', dragStart);
  track.addEventListener('touchstart', dragStart, {passive: true});
  track.addEventListener('mouseup', dragEnd);
  track.addEventListener('mouseleave', dragEnd);
  track.addEventListener('touchend', dragEnd);
  track.addEventListener('mousemove', dragAction);
  track.addEventListener('touchmove', dragAction, {passive: true});

  // Prevent native dragging of video elements (which interferes with our custom drag)
  document.querySelectorAll('video').forEach(vid => {
    vid.addEventListener('dragstart', (e) => e.preventDefault());
  });

  function dragStart(e) {
    isDragging = true;
    isClick = true;
    startPos = getPositionX(e);
    track.style.transition = 'none'; // Disable transition for snappy dragging
    animationID = requestAnimationFrame(animation);
  }

  function dragAction(e) {
    if (isDragging) {
      const currentPosition = getPositionX(e);
      const diff = currentPosition - startPos;
      
      // If moved more than 5px, count it as a drag, not a click
      if (Math.abs(diff) > 5) isClick = false; 
      currentTranslate = prevTranslate + diff;
    }
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    cancelAnimationFrame(animationID);
    
    const movedBy = currentTranslate - prevTranslate;
    
    // Snapping Threshold (100px)
    if (movedBy < -100 && currentIndex < slides.length - 1) {
      currentIndex += 1; // Snap forward
    } else if (movedBy > 100 && currentIndex > 0) {
      currentIndex -= 1; // Snap backward
    }
    
    // Use goToSlide to finalize movement and snap into place perfectly
    goToSlide(currentIndex);
  }

  function getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  function animation() {
    if (isDragging) {
      track.style.transform = `translateX(${currentTranslate}px)`;
      requestAnimationFrame(animation);
    }
  }

  const formatTime = (timeInSeconds) => {
    if (isNaN(timeInSeconds)) return "0:00";
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  document.querySelectorAll('.video-slider-wrapper').forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const centerPlayBtn = wrapper.querySelector('.video-slider-center-play');
    
    const progressBar = wrapper.querySelector('.video-slider-progress-bar');
    const currentTimeEl = wrapper.querySelector('.video-slider-current-time');
    const durationEl = wrapper.querySelector('.video-slider-duration');
    const fullscreenBtn = wrapper.querySelector('.video-slider-fullscreen-btn');
    const customControls = wrapper.querySelector('.video-slider-controls');

    // Prevent dragging the slider when interacting with the custom controls (e.g. progress bar)
    customControls.addEventListener('mousedown', (e) => e.stopPropagation());
    customControls.addEventListener('touchstart', (e) => e.stopPropagation(), {passive: true});

    // FIXED: Prevent dragging the slider when clicking the center play button
    centerPlayBtn.addEventListener('mousedown', (e) => e.stopPropagation());
    centerPlayBtn.addEventListener('touchstart', (e) => e.stopPropagation(), {passive: true});

    video.addEventListener('loadedmetadata', () => {
      durationEl.textContent = formatTime(video.duration);
    });

    const togglePlay = (e) => {
      // Only block the action if the video ITSELF was clicked AND it was recognized as a swipe
      // Clicking the dedicated centerPlayBtn will always bypass this and trigger play/pause
      if (e && e.currentTarget === video && !isClick) return; 

      if (video.paused) {
        document.querySelectorAll('video').forEach(v => {
          if (v !== video) v.pause();
        });
        video.play();
      } else {
        video.pause();
      }
    };

    centerPlayBtn.addEventListener('click', togglePlay);
    video.addEventListener('click', togglePlay);

    video.addEventListener('play', () => {
      wrapper.classList.remove('is-paused');
      wrapper.classList.add('is-playing');
    });

    video.addEventListener('pause', () => {
      wrapper.classList.remove('is-playing');
      wrapper.classList.add('is-paused');
    });

    video.addEventListener('timeupdate', () => {
      const progress = (video.currentTime / video.duration) * 100;
      progressBar.value = progress;
      currentTimeEl.textContent = formatTime(video.currentTime);
      
      const val = progressBar.value;
      progressBar.style.background = `linear-gradient(to right, #3b82f6 ${val}%, rgba(255,255,255,0.3) ${val}%)`;
    });

    progressBar.addEventListener('input', (e) => {
      const seekTime = (e.target.value / 100) * video.duration;
      video.currentTime = seekTime;
      
      const val = e.target.value;
      progressBar.style.background = `linear-gradient(to right, #3b82f6 ${val}%, rgba(255,255,255,0.3) ${val}%)`;
    });

    fullscreenBtn.addEventListener('click', () => {
      if (!document.fullscreenElement) {
        if (wrapper.requestFullscreen) {
          wrapper.requestFullscreen();
        } else if (wrapper.webkitRequestFullscreen) {
          wrapper.webkitRequestFullscreen();
        } else if (wrapper.msRequestFullscreen) {
          wrapper.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    });
  });

	
})();
